module.exports = __webpack_public_path__ + "img/work.1d60b9ac.png";